"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapLayerSwitcherBaseLayersSlider = void 0;
var Swipe_1 = require("ol-ext/control/Swipe");
var strongly_typed_events_1 = require("strongly-typed-events");
var MapLayerSwitcherBaseLayersSlider = /** @class */ (function () {
    function MapLayerSwitcherBaseLayersSlider(_map, _mapStore, _baseLayers, _mappingTextPack, _config) {
        var _this = this;
        this._map = _map;
        this._mapStore = _mapStore;
        this._baseLayers = _baseLayers;
        this._mappingTextPack = _mappingTextPack;
        this._config = _config;
        this._initialised = false;
        this._leftBaseLayer = null;
        this._rightBaseLayer = null;
        //event - Swipe moved
        this._onSliderMoved = new strongly_typed_events_1.SimpleEventDispatcher();
        this.init = function () {
            if (!_this._initialised) {
                _this.addOpacitySlider(_this._mapStore.getMapInfo().opacity);
                _this.addSwipe();
                _this.addBaseLayers();
                _this._initialised = true;
            }
        };
        this.addSwipe = function () {
            var self = _this;
            _this._swipe = new Swipe_1.default({
                position: _this._mapStore.getMapInfo().baseLayerSliderPosition || _this._config.baseLayerSliderPosition
            });
            // Originally inspired by  David Walsh (https://davidwalsh.name/javascript-debounce-function)
            // Returns a function, that, as long as it continues to be invoked, will not
            // be triggered. The function will be called after it stops being called for
            // `wait` milliseconds.
            var debounce = function (func, wait) {
                var timeout;
                return function executedFunction() {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    var later = function () {
                        clearTimeout(timeout);
                        func.apply(void 0, args);
                    };
                    clearTimeout(timeout);
                    timeout = setTimeout(later, wait);
                };
            };
            //only handle the final moving event
            var handleSwipeEnd = debounce(function (e) {
                self._onSliderMoved.dispatch({
                    x: Number(e.position[0]),
                    y: Number(e.position[1]),
                });
                //console.log("swipe moving:" + e.position[0]);
            }, 250);
            _this._swipe.on("moving", handleSwipeEnd);
            _this._map.olMap.addControl(_this._swipe);
        };
        this.addOpacitySlider = function (defaultOpacity) {
            _this._opacity = defaultOpacity;
            var onOpacityChanged = function (elem) {
                _this._opacity = elem.val() / 100;
                var opacityForScope = _this._opacity;
                for (var _i = 0, _a = _this._baseLayers; _i < _a.length; _i++) {
                    var l = _a[_i];
                    l.setOpacity(opacityForScope);
                }
                _this._mapStore.onOpacityChanged(_this._opacity);
            };
            //set initial opacity too
            for (var _i = 0, _a = _this._baseLayers; _i < _a.length; _i++) {
                var l = _a[_i];
                if (l.getVisible()) {
                    l.setOpacity(defaultOpacity);
                }
            }
            if ($(".mapSlider")[0]) {
                $(".mapSlider").slider({
                    min: 20,
                    max: 100,
                    value: defaultOpacity * 100
                }).on('change', function () {
                    onOpacityChanged($(this));
                });
                $(".mapSliderContainer .tooltip").hide();
            }
        };
        this.addBaseLayers = function () {
            _this.addMainLayers();
            _this.addComparisionLayer();
            _this.rebuildLayers(false);
        };
        this.addMainLayers = function () {
            _this._mapStore.getMapInfo().baselayers.forEach(function (value, key) {
                if (key.indexOf("comparison") === -1 && value === true) {
                    _this._map.baseLayers.forEach(function (bl) {
                        //find the matching base layer
                        if (bl.ref === key) {
                            _this._leftBaseLayer = bl;
                        }
                    });
                }
            });
            $("#panelBaseLayers").append("<h5>" + _this._mappingTextPack.mainLayer + "</h5>");
            //add the base layers to the layer switcher
            var ul = $("<ul>", { "class": "esdm-layer-switcher" });
            var pnl = $("#panelBaseLayers").append(ul);
            var self = _this;
            var _loop_1 = function (bLyr) {
                var li = $("<li>");
                var lyrId = "BaseLayer_main_" + bLyr.ref;
                var visible = (self._mapStore.getMapInfo().baselayers.get(bLyr.ref) === true);
                var radio = $("<input>", { id: lyrId, "type": "radio", "name": "main", "checked": visible });
                radio.change(function () {
                    self.onMainLayerVisibile(bLyr);
                });
                li.append(radio);
                li.append($("<label>", { for: lyrId, html: bLyr.displayName }));
                ul.append(li);
            };
            for (var _i = 0, _a = _this._baseLayers; _i < _a.length; _i++) {
                var bLyr = _a[_i];
                _loop_1(bLyr);
            }
        };
        this.addComparisionLayer = function () {
            _this._mapStore.getMapInfo().baselayers.forEach(function (value, key) {
                if (key.indexOf("comparison_") > -1 && value === true) {
                    var layerRef_1 = key.replace("comparison_", "");
                    _this._map.baseLayers.forEach(function (bl) {
                        //find the matching base layer
                        if (bl.ref === layerRef_1) {
                            bl.olLayer.setVisible(true);
                            _this._rightBaseLayer = bl;
                        }
                    });
                }
            });
            $("#panelBaseLayers").append("<h5>" + _this._mappingTextPack.comparisionLayer + "</h5>");
            //add the base layers to the layer switcher
            var ul = $("<ul>", { "class": "esdm-layer-switcher" });
            var pnl = $("#panelBaseLayers").append(ul);
            var self = _this;
            var anySelected = false;
            var _loop_2 = function (bLyr) {
                var li_1 = $("<li>");
                var lyrId = "BaseLayer_comparision_" + bLyr.ref;
                var visible = (self._mapStore.getMapInfo().baselayers.get("comparison_" + bLyr.ref) === true);
                var radio_1 = $("<input>", { id: lyrId, "type": "radio", "name": "comparision", "checked": visible });
                radio_1.change(function () {
                    self.onComparisonLayerVisibile(bLyr);
                });
                li_1.append(radio_1);
                li_1.append($("<label>", { for: lyrId, html: bLyr.displayName }));
                ul.append(li_1);
                if (visible) {
                    anySelected = true;
                }
            };
            for (var _i = 0, _a = _this._baseLayers; _i < _a.length; _i++) {
                var bLyr = _a[_i];
                _loop_2(bLyr);
            }
            var li = $("<li>");
            var radio = $("<input>", { id: "none", "type": "radio", "name": "comparision", "checked": !anySelected });
            radio.change(function () {
                self.onNoneComparisonLayerSelected();
            });
            li.append(radio);
            li.append($("<label>", { for: "none", html: _this._mappingTextPack.noComparisonLayer }));
            ul.append(li);
        };
        this.onMainLayerVisibile = function (bLyr) {
            _this._leftBaseLayer = bLyr;
            var layerRefToShow = bLyr.ref;
            _this._map.baseLayers.forEach(function (bl) {
                var currentLayerIsOneToShow = (bl.ref === layerRefToShow);
                //ignore the current comparison base layer
                if (_this._rightBaseLayer === null || bl.ref !== _this._rightBaseLayer.ref) {
                    bl.setVisible(currentLayerIsOneToShow);
                    bl.setOpacity(_this._opacity);
                }
                _this._mapStore.onBaseLayerChanged(bl.ref, currentLayerIsOneToShow);
            });
            _this.rebuildLayers();
        };
        this.onComparisonLayerVisibile = function (bLyr) {
            _this._rightBaseLayer = bLyr;
            var layerRefToShow = bLyr.ref;
            _this._map.baseLayers.forEach(function (bl) {
                var currentLayerIsOneToShow = (bl.ref === layerRefToShow);
                //ignore the current main base layer
                if (bl.ref !== _this._leftBaseLayer.ref) {
                    bl.setVisible(currentLayerIsOneToShow);
                    bl.setOpacity(_this._opacity);
                }
                _this._mapStore.onBaseLayerChanged("comparison_" + bl.ref, currentLayerIsOneToShow);
            });
            _this.rebuildLayers();
        };
        this.onNoneComparisonLayerSelected = function () {
            _this._map.baseLayers.forEach(function (bl) {
                _this._mapStore.onBaseLayerChanged("comparison_" + bl.ref, false);
            });
            if (_this._rightBaseLayer !== null && _this._leftBaseLayer.ref !== _this._rightBaseLayer.ref) {
                //if they are the same layer then hiding will also hide the left hand layer too
                _this._rightBaseLayer.setVisible(false);
            }
            _this.rebuildLayers(true);
        };
        this.init();
    }
    Object.defineProperty(MapLayerSwitcherBaseLayersSlider.prototype, "onSliderMoved", {
        get: function () {
            return this._onSliderMoved.asEvent();
        },
        enumerable: false,
        configurable: true
    });
    MapLayerSwitcherBaseLayersSlider.prototype.rebuildLayers = function (noComparisonLayer) {
        if (noComparisonLayer === void 0) { noComparisonLayer = false; }
        if (this._leftBaseLayer !== null) {
            this._swipe.removeLayer(this._leftBaseLayer.olLayer);
        }
        if (this._rightBaseLayer !== null) {
            this._swipe.removeLayer(this._rightBaseLayer.olLayer);
        }
        if (noComparisonLayer) {
            this._rightBaseLayer = null;
        }
        if (this._rightBaseLayer === null) {
            $(".ol-swipe").hide();
        }
        else {
            $(".ol-swipe").show();
        }
        //only add if the layers are different and we have a right hand layers
        if (this._rightBaseLayer !== null && this._leftBaseLayer.ref !== this._rightBaseLayer.ref) {
            this._swipe.addLayer(this._leftBaseLayer.olLayer, false);
            this._swipe.addLayer(this._rightBaseLayer.olLayer, true);
        }
    };
    return MapLayerSwitcherBaseLayersSlider;
}());
exports.MapLayerSwitcherBaseLayersSlider = MapLayerSwitcherBaseLayersSlider;
//# sourceMappingURL=MapLayerSwitcherBaseLayersSlider.js.map